import type { Service } from '../../posApi/services/service'
import type { AppointmentItem } from './appointment-item'

export class AppointmentConsumption {
    appointmentConsumptionId?: string
    appointmentId?: string
    serviceId: string
    service?: Service // produto consumível (shampoo, luva...) — só usado no frontend, não vai pro backend
    // item do agendamento que originou este consumo via receita (BOM) do serviço — só usado no frontend
    // (appointment-form-block.svelte), pra saber desvincular/remover se o item for removido depois
    sourceItem?: AppointmentItem
    // preenchido automaticamente pela receita (BOM) e ainda não confirmado pelo atendente — abre direto em
    // modo de edição, já que "Eu estou" fica em branco por padrão (ver appointment-form-consumption.svelte)
    startInEditMode?: boolean
    performedServiceId?: string
    userId?: string
    loggedUserId?: string
    personId?: string
    quantity: number
    openNew?: boolean
    closeAfter?: boolean
    comissionCost?: number
    canceled?: boolean // o consumo não aconteceu (reverte o estoque no pos-api)
    // estorno só da cobrança na comissão do atendente: o insumo segue consumido e o estoque baixado
    comissionCanceled?: boolean
    // true quando já foi efetivado no estoque do pos-api. consumo por unidade só é efetivado com o agendamento
    // em "Compareceu" — até lá fica syncStatus 'pending' + applied false (não é sincronização em andamento)
    applied?: boolean
    syncStatus?: 'pending' | 'synced' | 'failed'
    syncError?: string
    createdAt?: Date
    updatedAt?: Date
}
